import React from 'react';
import ContactSection from '../components/ContactSection/ContactSection';
import './PageHeader.css';

const ContactPage = () => {
  return (
    <main className="contact-page">
     

      {/* Main Contact Section with Form, Contact Info & Map */}
      <ContactSection />

      
    </main>
  );
};

export default ContactPage;
